export const getId = (object?: Record<string, any>): number | null =>
    object ? object.id : null;

export const toArray = (value: string): any =>
    value && value.split(',').map(Number);

export const toArrayIfFalsy = (value: any): any | [] => value || [];

export const toNumberIfValueNotNaN = (value: any): any => {
    const valueAsNumber = Number(value);
    return value && !isNaN(valueAsNumber) ? valueAsNumber : value;
};

export const toNumber = (value: any): number | null =>
    value && !isNaN(value) ? Number(value) : null;

export const toNumberOrNull = (value: any): number | null =>
    value ? Number(value) : null;

export const toNull = (value: any): any | null => value || null;

export const toNullIfNaN = (value: any): any | null =>
    !value && value !== 0 ? null : value;

export default {
    getId,
    toArray,
    toArrayIfFalsy,
    toNumberIfValueNotNaN,
    toNumber,
    toNumberOrNull,
    toNull,
    toNullIfNaN
};
